"use strict";

const NewsController = function (CRUDService, config) {
    var ctrl = this;

    var currentPage = 0;
    var totalPages;

    ctrl.$onInit = function(){
      CRUDService.getAll(config.urls.news, undefined, 'publishDate,desc').then(function (data) {
        ctrl.news = data._embedded.news;
        totalPages = data.page.totalPages;
      });
    };

    ctrl.getNextPage = function() {
      if ((currentPage + 1) < totalPages) {
        currentPage++;
        CRUDService.getAll(config.urls.news, currentPage, 'publishDate,desc').then(function (data) {
          ctrl.news = ctrl.news.concat(data._embedded.news);
        });
      }
    };

    ctrl.shorten = function(term){
      var match = term.match(/^([\S\n]+[\s]){54}/);
      if (match) {
        return match[0];
      } else {
        return term;
      }
    };
  };

NewsController.$inject = ['CRUDService', 'config']

module.exports = {
  template: require('./news.html'),
  controller: NewsController
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/app/components/news/news.component.js